const colorMap = {
  Beige: "#F5F5DC",
  Black: "#000000",
  Blue: "#0000FF",
  Brown: "#A52A2A",
  Burgundy: "#800020",
  Coral: "#FF7F50",
  Cream: "#FDFBD4",
  Green: "#008000",
  Grey: "#808080",
  Ivory: "#FFFFF0",
  Lime: "#00FF00",
  Maroon: "#800000",
  Mauve: "#E0B0FF",
  Mint: "#98FF98",
  Navy: "#000080",
  Olive: "#808000",
  Orange: "#FFA500",
  Peach: "#FFE5B4",
  Pink: "#FFC0CB",
  Pista: "#93C572",
  Purple: "#800080",
  Red: "#FF0000",
  Rust: "#B7410E",
  Teal: "#008080",
  Violet: "#8F00FF",
  White: "#FFFFFF",
  Wine: "#722F37",
  Yellow: "#FFFF00",
  "Off White": "#F8F0E3",

  // normalized keys
  "Multi Colour": "#CCCCCC",
  "OffWhite": "#F8F0E3"
};

const searchLink = document.querySelector(".header__search-link");

if (searchLink) {
  searchLink.addEventListener("click", function () {

    setTimeout(function () {
      const input = document.querySelector(".header-search__input.h5.sm\\:h4");

      if (input) {
        input.click();
        input.focus(); // better UX
      }
    }, 500);

  });
}

const input = document.querySelector('.header-search__input.h5.sm\\:h4');

if (input) {
  input.addEventListener('click', function () {
    setTimeout(() => {
    bucksCC.reConvert();
        
    }, 500);
  });

  input.addEventListener('input', function () {
    bucksCC.reConvert();
  });
}

// Wizzy cards are client-rendered, but the price app (aiod) is Liquid + inline script.
// Best approach: fetch server-rendered snippet per handle and inject; then execute inline scripts.
const __wizzyPriceHtmlByHandle = new Map();
const __wizzyPriceFetchInFlight = new Map();

function wizzyRunInlineScripts(container) {
  if (!container) return;
  const scripts = Array.from(container.querySelectorAll('script'));
  for (const oldScript of scripts) {
    const s = document.createElement('script');
    for (const attr of Array.from(oldScript.attributes || [])) {
      s.setAttribute(attr.name, attr.value);
    }
    s.text = oldScript.textContent || '';
    oldScript.parentNode && oldScript.parentNode.replaceChild(s, oldScript);
  }
}

function wizzyBuildPriceSectionUrl(handle, rawProductUrl) {
  try {
    if (rawProductUrl) {
      const u = new URL(rawProductUrl, window.location.origin);
      // Use view template (more reliable than ?sections= for non-template section types)
      u.searchParams.delete('sections');
      u.searchParams.set('view', 'wizzy-price');
      return u.toString();
    }
  } catch (_) {}

  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return `${base}products/${encodeURIComponent(handle)}?view=wizzy-price`;
}

async function wizzyFetchPriceHtmlByHandle(handle, rawProductUrl) {
  if (__wizzyPriceHtmlByHandle.has(handle)) {
    return __wizzyPriceHtmlByHandle.get(handle);
  }
  if (__wizzyPriceFetchInFlight.has(handle)) {
    return __wizzyPriceFetchInFlight.get(handle);
  }
  const url = wizzyBuildPriceSectionUrl(handle, rawProductUrl);
  const p = fetch(url, { credentials: 'same-origin' })
    .then(async (res) => {
      if (!res.ok) throw new Error(`wizzy-price fetch failed: ${res.status}`);
      const out = await res.text();
      __wizzyPriceHtmlByHandle.set(handle, out);
      return out;
    })
    .finally(() => {
      __wizzyPriceFetchInFlight.delete(handle);
    });
  __wizzyPriceFetchInFlight.set(handle, p);
  return p;
}

async function wizzyHydratePrices(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const slots = Array.from(
    scope.querySelectorAll('.wizzy-price-slot[data-wizzy-handle]:not([data-wizzy-price-hydrated])')
  );
  if (!slots.length) return;

  // Map handle -> product URL (optional)
  const urlByHandle = new Map();
  for (const n of slots) {
    const h = (n.getAttribute('data-wizzy-handle') || '').trim();
    const u = (n.getAttribute('data-wizzy-url') || '').trim();
    if (h && u && !urlByHandle.has(h)) urlByHandle.set(h, u);
  }

  const handles = Array.from(
    new Set(
      slots
        .map((n) => (n.getAttribute('data-wizzy-handle') || '').trim())
        .filter(Boolean)
    )
  );

  const limit = 6;
  let idx = 0;
  async function worker() {
    while (idx < handles.length) {
      const h = handles[idx++];
      try {
        await wizzyFetchPriceHtmlByHandle(h, urlByHandle.get(h));
      } catch (_) {
        __wizzyPriceHtmlByHandle.set(h, '');
      }
    }
  }
  await Promise.all(Array.from({ length: Math.min(limit, handles.length) }, worker));

  for (const node of slots) {
    const handle = (node.getAttribute('data-wizzy-handle') || '').trim();
    if (!handle) continue;
    node.setAttribute('data-wizzy-price-hydrated', 'loading');
    node.removeAttribute('data-wizzy-price-error');
    const html = __wizzyPriceHtmlByHandle.get(handle) || '';
    try {
      // If the endpoint returns <price-list>, avoid nesting it inside another <price-list>.
      if (node.tagName && node.tagName.toLowerCase() === 'price-list') {
        const trimmed = String(html || '').trim();
        const m = trimmed.match(/^<price-list[^>]*>([\s\S]*)<\/price-list>\s*$/i);
        node.innerHTML = m ? m[1] : trimmed;
      } else {
        node.innerHTML = html;
      }
      wizzyRunInlineScripts(node);
      node.setAttribute('data-wizzy-price-hydrated', 'true');
      if (!html) {
        node.setAttribute('data-wizzy-price-error', 'empty-section-html');
      }
    } catch (e) {
      node.setAttribute('data-wizzy-price-hydrated', 'error');
      node.setAttribute('data-wizzy-price-error', 'inject-failed');
    }
  }
}



window.onWizzyScriptLoaded = function () {
window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_PRODUCTS_RESULTS_RENDERED,
  function (data) {
    // var html = data && data.html;
    // console.log('BEFORE_PRODUCTS_RESULTS_RENDERED length', html ? html.length : 0);
    // console.log('has summary mount', html && html.indexOf('wizzy-search-summary') !== -1);
    // console.log('snippet', html && html.slice(0, 500));
    return data;
  }
);
window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
    bucksCC.reConvert();
    wizzyHydratePrices(document.querySelector('.wizzy-search-wrapper'));
    if (
        window.wizzyConfig &&
        window.wizzyConfig.common &&
        window.wizzyConfig.common.isOnCategoryPage
      ) {
        const el = document.querySelector(".wizzy-main-content .prose.text-center h1");

        if (el && window.wizzyConfig.common.categoryName) {
          el.textContent = window.wizzyConfig.common.categoryName;
        }
      }
    wizzySyncLayoutToolbarActiveStates();
    window.WH_TimeOutForCustomButtonsDetection = 500;
    const queryCountEle = document.querySelector(".collection-toolbar__products-count");
    if (queryCountEle) {
      queryCountEle.textContent = data?.data?.response?.payload?.total + " PRODUCTS" ;
    }
    document.querySelectorAll('.wizzy-search-wrapper .wishlist-hero-custom-button').forEach(function (item) {
      if (item.querySelector('button')) return;
      document.dispatchEvent(
        new CustomEvent('wishlist-hero-add-to-custom-element', {
          detail: item
        })
      );
    });
    
    document.querySelectorAll('.wizzy-autocomplete-top-products .wishlist-hero-custom-button').forEach(function (item) {
      if (item.querySelector('button')) return;
      document.dispatchEvent(
        new CustomEvent('wishlist-hero-add-to-custom-element', {
          detail: item
        })
      );
    });

    return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
        data.filters.attributeFacetValuesLimit = 100;

        if (!Array.isArray(data.filters.sort)) {
        data.filters.sort = [];
        }

        const exists = data.filters.sort.find(
        s => s.field === "product_wizzy-best-selling_sortOrder:float"
        );

        if (!exists) {
        data.filters.sort.push({
            field: "product_wizzy-best-selling_sortOrder:float",
            order: "asc"
        });
        }

        return data;
    }
    );
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(payload) {
        // if (payload.api === "search" || payload.api === "filter") {
        //     var facets = payload.response.payload.facets;
        //     facets && facets.forEach(facet => {
        //         if (facet.key === "product_Color_tags") {
        //             let facet_data = facet.data;
        //             facet_data && facet_data.forEach(item => {
        //                 let color = colorMap[item.label] || "#000000";
        //                 item.isSwatch = !0,
        //                 item.isURLSwatch = !1,
        //                 item.isVisualSwatch = !0,
        //                 item.swatchValue = color,
        //                 item.data = {
        //                     value: item.key,
        //                     swatch: {
        //                         type: "visual",
        //                         value: color
        //                     }
        //                 },
        //                 item.code = color;
        //             }
        //             )
        //         }
        //     }
        //     );
        // }
        return payload
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach(function (product) {
        product.attributes.forEach(function (attr) {
          if (attr.id == 'product_handle') {
            product.handle = attr.values[0].value[0];
          }
        });

        if (
        typeof product.price !== "undefined" &&
        product.price &&
        product.price.toString().includes(".")
        ) {
        product.price = product.price.toString().split(".")[0];
        }

        if (
        typeof product.sellingPrice !== "undefined" &&
        product.sellingPrice &&
        product.sellingPrice.toString().includes(".")
        ) {
        product.sellingPrice = product.sellingPrice.toString().split(".")[0];
        }
      });

      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function (data) {
    window.wizzyConfig.filters.configs.displayAsDrawer = !0;
    data.search.configs.facets.showPriceInputRangeFields = true;
    data.search.configs.facets.leftFacets.mobileCollapsible = !0;
    data.search.configs.pagination.appendInExistingList = !0;
    if (window.wizzyConfig?.common?.isOnCategoryPage) {
  document.body.classList.add('wizzy-collection-page');
}
    data.filters.configs.keepOpenedInMobileAfterApply = !0;
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];

    return data;
  });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (data) {
      const headerSearch = document.querySelector("header-search.header-search");
      headerSearch?.hasAttribute("open") && headerSearch.removeAttribute("open");
      data.attributeFacetValuesLimit = 100;

    return data;
  });
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function (data) {
    window.wizzyConfig.filters.configs.displayAsDrawer = !0;
    data.search.configs.facets.showPriceInputRangeFields = true;
    data.search.configs.facets.leftFacets.mobileCollapsible = !0;
    data.search.configs.pagination.appendInExistingList = !0;
    data.filters.configs.keepOpenedInMobileAfterApply = !0;
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];

    return data;
  });

  function wizzyResolveSearchWrapperFromLayoutSwitch(layoutSwitch) {
    var toolbar = layoutSwitch && layoutSwitch.closest('height-observer.collection-toolbar');
    var next = toolbar && toolbar.nextElementSibling;
    if (next && next.classList && next.classList.contains('wizzy-search-wrapper')) {
      return next;
    }
    return document.querySelector('.wizzy-search-wrapper');
  }

  function wizzySyncLayoutToolbarActiveStates() {
    var wrapper =
      document.querySelector('.wizzy-search-wrapper') ||
      wizzyResolveSearchWrapperFromLayoutSwitch(document.querySelector('.wizzy-search-layout-switch'));
    if (!wrapper) return;
    if (!wrapper.hasAttribute('wizzy-tile-view-level')) {
      wrapper.setAttribute('wizzy-tile-view-level', '2');
    }
    if (!wrapper.hasAttribute('wizzy-mobile-grid')) {
      wrapper.setAttribute('wizzy-mobile-grid', 'medium');
    }

    var layoutRoot = document.querySelector('.wizzy-search-layout-switch');
    if (layoutRoot) {
      var level = String(wrapper.getAttribute('wizzy-tile-view-level') || '2');
      layoutRoot.querySelectorAll('.wizzy-layout-btn').forEach(function (btn) {
        var bl = btn.getAttribute('data-wizzy-tile-level');
        btn.classList.toggle('is-active', bl === level);
      });
    }

    var mobileRoot = document.querySelector('.wizzy-search-layout-switch-mobile');
    if (mobileRoot) {
      var grid = String(wrapper.getAttribute('wizzy-mobile-grid') || 'large');
      mobileRoot.querySelectorAll('.wizzy-layout-btn-mobile').forEach(function (btn) {
        var g = btn.getAttribute('data-wizzy-mobile-grid');
        btn.classList.toggle('is-active', g === grid);
      });
    }
  }

  if (!window.__wizzyLayoutToolbarClickBound) {
    window.__wizzyLayoutToolbarClickBound = true;
    document.addEventListener('click', function (e) {
      var btnDesktop = e.target.closest('.wizzy-search-layout-switch .wizzy-layout-btn');
      var btnMobile = e.target.closest('.wizzy-search-layout-switch-mobile .wizzy-layout-btn-mobile');
      var layoutRoot = btnDesktop
        ? btnDesktop.closest('.wizzy-search-layout-switch')
        : btnMobile && btnMobile.closest('.wizzy-search-layout-switch-mobile');
      if (!layoutRoot) return;

      var wrapper = wizzyResolveSearchWrapperFromLayoutSwitch(layoutRoot);
      if (!wrapper) return;

      if (btnDesktop) {
        var level = btnDesktop.getAttribute('data-wizzy-tile-level');
        if (!level) return;
        wrapper.setAttribute('wizzy-tile-view-level', level);
        layoutRoot.querySelectorAll('.wizzy-layout-btn').forEach(function (b) {
          b.classList.toggle('is-active', b === btnDesktop);
        });
        return;
      }

      if (btnMobile) {
        var grid = btnMobile.getAttribute('data-wizzy-mobile-grid');
        if (!grid) return;
        wrapper.setAttribute('wizzy-mobile-grid', grid);
        layoutRoot.querySelectorAll('.wizzy-layout-btn-mobile').forEach(function (b) {
          b.classList.toggle('is-active', b === btnMobile);
        });
      }
    });
  }

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function (data) {
    bucksCC.reConvert();
    if (
        window.wizzyConfig &&
        window.wizzyConfig.common &&
        window.wizzyConfig.common.isOnCategoryPage
      ) {
        const el = document.querySelector(".wizzy-main-content .prose.text-center h1");

        if (el && window.wizzyConfig.common.categoryName) {
          el.textContent = window.wizzyConfig.common.categoryName;
        }
      }
    wizzySyncLayoutToolbarActiveStates();
    window.WH_TimeOutForCustomButtonsDetection = 500;
    const queryCountEle = document.querySelector(".collection-toolbar__products-count");
    if (queryCountEle &&   window.wizzyConfig.common.isOnCategoryPage) {
      queryCountEle.textContent = data?.data?.response?.payload?.total + " PRODUCTS" ;
    }
    document.querySelectorAll('.wizzy-search-wrapper .wishlist-hero-custom-button').forEach(function (item) {
      if (item.querySelector('button')) return;
      document.dispatchEvent(
        new CustomEvent('wishlist-hero-add-to-custom-element', {
          detail: item
        })
      );
    });
    
    document.querySelectorAll('.wizzy-autocomplete-top-products .wishlist-hero-custom-button').forEach(function (item) {
      if (item.querySelector('button')) return;
      document.dispatchEvent(
        new CustomEvent('wishlist-hero-add-to-custom-element', {
          detail: item
        })
      );
    });
    wizzyHydratePrices(document.querySelector('.wizzy-search-wrapper'));
    return data;
  });

          const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
    }
    const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
    }
      , callback = function (mutationsList, observer2) {
        for (const mutation of mutationsList) {
          updateBodyClass();
          break
        }
      }
    ,observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());
};
